import PurchaseFooter from '@activities/order/OrderActivity/components/PurchaseFooter';
import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import useAppCustom from '@hooks/useAppCustom';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import useCopyRequest from '@store/order/hooks/useCopyRequest';
import { useTranslation } from 'react-i18next';

import CashReceipt from './components/CashReceipt';
import Discount from './components/Discount';
import Items from './components/Items';
import OrderNote from './components/OrderNote';
import OrderTermNotes from './components/OrderTermNotes';
import OrderTypeSelector from './components/OrderTypeSelector';
// import PaymentFooter from './components/PaymentFooter';
import PaymentMethod from './components/PaymentMethod';
import Shop from './components/Shop';
import styles from './styles.module.scss';

interface Params {
  path?: 'cart' | 'direct';
  itemActivityId?: string;
}

declare module '@stackflow/config' {
    interface Register {
        OrderActivity: Params;
    }
}

const OrderActivity: ActivityComponentType<'OrderActivity'> = ({ params }) => {
    const { paymentOrderButtonPosition } = useAppCustom().payment;
    const { path, itemActivityId } = params;
    useCopyRequest(path, itemActivityId);
    const { t } = useTranslation('order');
    return (
        <AppScreen>
            <CtaLayout footerPosition={paymentOrderButtonPosition}
                header={<Header title={t('header.title')} />}
                footer={<PurchaseFooter/>} >
                <Column className={styles.contents}
                    fullWidth>
                    <Shop/>
                    <Items/>
                    <Divider/>
                    <Discount />
                    <PaymentMethod/>
                    <OrderTypeSelector/>
                    <CashReceipt/>
                    {/* <PickupOption/> */}
                    <OrderNote/>
                    <OrderTermNotes/>
                    <div id='payment-method' style={{ width: '100%' }}/>
                    <div id='agreement' style={{ width: '100%' }}/>
                    {/* <PaymentFooter/> */}
                </Column>
            </CtaLayout>
        </AppScreen>
    );
};

export default OrderActivity;
